import { render, staticRenderFns } from "./CPagination.vue?vue&type=template&id=237bab0e&scoped=true&"
import script from "./CPagination.vue?vue&type=script&lang=js&"
export * from "./CPagination.vue?vue&type=script&lang=js&"
import style0 from "./CPagination.vue?vue&type=style&index=0&id=237bab0e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "237bab0e",
  null
  
)

export default component.exports